import React from 'react';
import {useTranslate} from "../../system/useTranslate";

function PageHeaderButton({title, description, end, titleClassName = ""}) {
    const translate = useTranslate();
    return (
        <div className="flex justify-content-between w-full p-3 pt-0 pb-0 gap-2">
            <div className="w-6 lg:w-fit">
                <h1 className={`m-0 ${titleClassName}`}>{translate(title)}</h1>
                <span className="text-xs text-400">{translate(description)}</span>
            </div>
            <div className="flex-1 flex justify-content-end h-fit">
                {end}
            </div>
        </div>


    );
}

export default PageHeaderButton;
